import { render, staticRenderFns } from "./PublicBlogArticle.vue?vue&type=template&id=47e8139a"
import script from "./PublicBlogArticle.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicBlogArticle.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports